import { StatusCode } from '@hungryroot/rest';
import { getV2PromoCode } from '@hungryroot/rest/api/v2/promo/[code]/get';

export interface InvalidPromoCode {
  valid: false;
  message: string;
}

export const validatePromoCode = async (promoCode: string) => {
  const resp = await getV2PromoCode(promoCode);

  const { status, data } = resp;

  if (status === StatusCode.ClientErrorNotFound) {
    return {
      valid: false,
      message: 'invalid promo code',
    } as InvalidPromoCode;
  }

  if (status !== StatusCode.SuccessOK) {
    throw data;
  }

  return data;
};
